"use client";

import {
  Dialog as UnsafeDialog,
  Menu as UnsafeMenu,
  Transition as UnsafeTransition,
  Combobox as UnsafeCombobox,
} from "@headlessui/react";
import { ElementType, FC, PropsWithChildren } from "react";

export const Dialog = UnsafeDialog;
export const DialogBackdrop = UnsafeDialog.Backdrop;
export const DialogPanel = UnsafeDialog.Panel;
export const DialogOverlay = UnsafeDialog.Overlay;
export const DialogTitle = UnsafeDialog.Title;
export const DialogDescription = UnsafeDialog.Description;

export const Menu = UnsafeMenu;
export const MenuButton = UnsafeMenu.Button;
export const MenuItems = UnsafeMenu.Items;
export const MenuItem = UnsafeMenu.Item;

export const Transition = UnsafeTransition;
export const TransitionRoot = Transition.Root;
export const TransitionChild = Transition.Child;

export const Combobox = UnsafeCombobox;
export const ComboboxInput = Combobox.Input;
export const ComboboxButton = Combobox.Button;
export const ComboboxLabel = Combobox.Label;
export const ComboboxOptions = Combobox.Options;
export const ComboboxOption = Combobox.Option;
